// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"EZ-z","sponsoredTooltipWrapper":"FZ-z","sponsoredTooltip":"GZ-z","newCard":"HZ-z"};